<template>
  <v-alert
    id="premium-feature"
    class="mb-4"
    border="left"
    dense
    text
    outlined
    type="info"
    elevation="1"
  >
    <span>{{ text }}</span>
  </v-alert>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'This is a premium feature'
    }
  }
}
</script>
